import { OdataManager } from '@/api/odata/odata-manager';
import { ProjectDocumentationStage } from '@/api/model/interfaces';

export default class ProjectDocumentationStageOdata extends OdataManager<ProjectDocumentationStage> {}
